<template>
  <section
    v-show="isActive"
    :id="computedId"
    ref="tab"
    :aria-hidden="! isActive"
    class="koc-tab-panel"
    role="tabpanel"
  >
    <slot />
  </section>
</template>

<script src="./tab.js"></script>
<style lang="scss" scoped src="./tab.scss"></style>
